// Direct Representative Discrepancy Audit — Region-scoped "Radar only" (ADR-130).
// Mirrors radar-api src/utils/discrepancyTypes.js.

export const DISCREPANCY_RADAR_ONLY_REASONS = {
  REGION_MISMATCH:     'REGION_MISMATCH',
  DROPPED_FROM_SOURCE: 'DROPPED_FROM_SOURCE',
  NEVER_SOURCED:       'NEVER_SOURCED',
};

export const DISCREPANCY_RADAR_ONLY_REASON_LABELS = {
  [DISCREPANCY_RADAR_ONLY_REASONS.REGION_MISMATCH]:     'Region mismatch',
  [DISCREPANCY_RADAR_ONLY_REASONS.DROPPED_FROM_SOURCE]: 'Dropped from source',
  [DISCREPANCY_RADAR_ONLY_REASONS.NEVER_SOURCED]:       'Never sourced',
};

// One source for the tooltip copy (run detail chips + Reader's Guide wording).
export const DISCREPANCY_RADAR_ONLY_REASON_DESCRIPTIONS = {
  [DISCREPANCY_RADAR_ONLY_REASONS.REGION_MISMATCH]:
    'Present in another source\'s feed. The Region in radar is probably wrong, or a transfer was not reflected.',
  [DISCREPANCY_RADAR_ONLY_REASONS.DROPPED_FROM_SOURCE]:
    'This source reported them before but not on this run. Likely a missed leaver or an email / UPN change.',
  [DISCREPANCY_RADAR_ONLY_REASONS.NEVER_SOURCED]:
    'This source has never reported them. Usually created by hand into this Region, or external.',
};

export const DISCREPANCY_RADAR_ONLY_REASON_COLORS = {
  [DISCREPANCY_RADAR_ONLY_REASONS.REGION_MISMATCH]:     'info',
  [DISCREPANCY_RADAR_ONLY_REASONS.DROPPED_FROM_SOURCE]: 'error',
  [DISCREPANCY_RADAR_ONLY_REASONS.NEVER_SOURCED]:       'warning',
};

export const DISCREPANCY_RADAR_ONLY_REASON_OPTIONS = Object.values(DISCREPANCY_RADAR_ONLY_REASONS).map((value) => ({
  value,
  label: DISCREPANCY_RADAR_ONLY_REASON_LABELS[value],
}));

// ---- Region system of record (ADR-130 D1) ----

export const REGION_SYSTEMS_OF_RECORD = {
  ENOVA:    'ENOVA',
  AMERICAS: 'AMERICAS',
  RADAR:    'RADAR',
};

export const REGION_SYSTEM_OF_RECORD_LABELS = {
  [REGION_SYSTEMS_OF_RECORD.ENOVA]:    'Enova',
  [REGION_SYSTEMS_OF_RECORD.AMERICAS]: 'Americas',
  [REGION_SYSTEMS_OF_RECORD.RADAR]:    'Radar (no upstream)',
};

export const REGION_SYSTEM_OF_RECORD_OPTIONS = Object.values(REGION_SYSTEMS_OF_RECORD).map((value) => ({
  value,
  label: REGION_SYSTEM_OF_RECORD_LABELS[value],
}));
